import { render, staticRenderFns } from "./BindsBadge.vue?vue&type=template&id=4f2308c1&"
import script from "./BindsBadge.vue?vue&type=script&lang=js&"
export * from "./BindsBadge.vue?vue&type=script&lang=js&"
import style0 from "./BindsBadge.vue?vue&type=style&index=0&id=4f2308c1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports